<template>
  <div class="container-cap">
    <div class="row">
      <div class="col-xs-12">
        <h2>
          Caractéristiques
          <span :class='`label label-${module}`'>
            {{moduleName}}
          </span>
          <div v-if="dataset != null">
            <p>
              <small>
                Pour les fiches issues des Données «{{ dataset }}»
              </small>
            </p>
            <dropdown tag="span" block>
              <btn type="primary" class="dropdown-toggle" role="button"
                   size="sm"
                   id="finess-list">
                Changer &nbsp;&nbsp;
                <span class="caret"></span>
              </btn>
              <template slot="dropdown">
                <li v-if="caracteristics.spiadi">
                  <a role="button"
                     @click="dataset = caracteristics.spiadi"
                     :disabled="dataset === caracteristics.spiadi">
                    {{ caracteristics.spiadi }}
                  </a>
                </li>
                <li v-for="(c, k) in caracteristics.others"
                    :key="`change-carac-${k}`">
                  <a role="button"
                     @click="dataset = c"
                     :disabled="dataset === c">
                    {{ c }}
                  </a>
                </li>
              </template>
            </dropdown>
          </div>
        </h2>
        <hr>
        <span v-if="module != null">
          <span v-show="dataset && !display">
            <strong>
              <loading-text>Téléchargement des fiches</loading-text>
            </strong>
          </span>
        </span>
      </div>
    </div>
    <div class="row" v-if="dataset == null">
      <div v-if="surveillance == null" class="col-xs-12">
        <strong>
          <loading-text>Chargement de la surveillance</loading-text>
        </strong>
      </div>
      <div v-else class="col-xs-12">
        <alert type="warning">
          <p class="text-justify">
            <strong>
              Merci de sélectionner les données pour lesquelles vous
              souhaitez obtenir vos caractéristiques.
            </strong>
          </p>
        </alert>
        <div>
          <h3>Vos données envoyées au programme national</h3>
          <div class="row">
            <div class="col-xs-6 col-md-4 col-lg-3 open-button-container">
              <button :class="`btn btn-${module} btn-block`"
                   class="open-button"
                   @click="dataset = caracteristics.spiadi">
                <strong>{{ caracteristics.spiadi }}</strong>
              </button>
            </div>
          </div>
        </div>
        <div v-if="caracteristics.others.length > 0">
          <h3>Vos données personnalisées</h3>
          <div class="row">
            <div v-for="(c, k) in caracteristics.others"
                 class="col-xs-6 col-md-4 col-lg-3 open-button-container"
                 :key="`nav-carac-${k}`">
              <button :class="`btn btn-${module} btn-block`"
                   class="open-button"
                   @click="dataset = c">
                <strong>{{ c }}</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="display">
      <div class="col-xs-12">
        <sui-filter-input v-model="filteredSheets"
                          :list="all.list"
                          :variables="filterVariables">
          <p>
            Le champ texte ci-dessous vous permet de filtrer les fiches
            prises en compte dans le calcul des statistiques. Les
            caractéristiques seront immédiatement recalculés en tenant compte du
            filtre choisit, vous permettant d'explorer les données en
            profondeur.
          </p>
        </sui-filter-input>
      </div>
      <div class="col-xs-12">
        <div v-if="flatDistribution != null">
          <sui-results-caracteristics
            :caracteristics="flatDistribution"
            :title="title"
            :subtitle="subtitle">
            <p>Aucune fiche pour cet établissement.</p>
          </sui-results-caracteristics>
        </div>
        <div v-else-if="filteredSheets.filter !== ''">
          <alert type="warning">
            <p>
              Aucune fiche ne correspond au filtre choisi.
            </p>
          </alert>
        </div>
        <div v-else>
          <alert type="warning">
            <strong>
              Aucune fiche n'a été remplie par cet établissement.
            </strong>
          </alert>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loading from '@/sui/components/loadingtext'
import { mapGetters } from 'vuex'
import distribution from '@/sui/data/distribution'
import caracteristics from '@/sui/data/caracteristics'
import sc from '@/sui/sc/sheetCaracteristics'
import suiResultsCaracteristics from '@/sui/components/results/caracteristics'
import suiFilterInput from '@/sui/components/dataFilterInput'
import modules from '@/sui/data/modules'
import ice from '@/sui/tools/ice'

export default {
  name: 'sheets-caracteristics',

  data: function () {
    return {
      text: '',
      pdfOptions: {
        legend: false,
        showUfs: true
      },
      filteredSheets: { filter: '', list: [] },
      all: null,
      sc: sc,
      dataset: null
    }
  },

  methods: {
    getSheets: function () {
      const vm = this
      const module = vm.module
      vm.all = null
      vm.$store.dispatch(
        'surveillances/getDatasetSheets',
        {
          mod: module,
          surv: vm.surveillance.id,
          name: vm.dataset,
          year: vm.surveillance.year
        }
      ).then(
        (res) => {
          if (res.data.err != null) {
            vm.error.set(
              'Erreur interne !',
              `Une erreur inattendue s'est produite lors de la récupération
des fiches.`,
              `Merci de vérifier votre connexion internet avant de réessayer.`
            )
            return res
          }

          vm.all = {
            module: module,
            list: ice.freeze(res.data.v),
            available: true
          }
          return res
        }
      )
    }
  },

  mounted: function () {
    if (this.surveillance != null && this.dataset != null) {
      this.getSheets()
    }
  },

  watch: {
    surveillance: function () {
      if (this.dataset != null) {
        this.getSheets()
      }
    },

    dataset: function () {
      this.getSheets()
    }
  },

  computed: {
    ...mapGetters({
      get: 'surveillances/get',
      userId: 'user/id'
    }),

    surveillance: function () {
      return this.get(this.$route.params.year, this.$route.params.id)
    },

    title: function () {
      const e = this.surveillance.establishment.name
      return `${this.dataset} - ${e} - Caractéristiques des fiches ${this.moduleName}`
    },

    subtitle: function () {
      if (this.filteredSheets.filter === '') {
        return ''
      }

      return `Filtre actif : ${this.filteredSheets.filter}`
    },

    year: function () {
      return this.$route.params.year
    },

    module: function () {
      return this.$route.params.st
    },

    filterVariables: function () {
      return sc.filterVariables[this.module](this.year)
    },

    moduleName: function () {
      if (this.module == null) {
        return null
      }

      return modules[this.year][this.module].label
    },

    display: function () {
      return this.all != null && this.all.available
    },

    referenceSheets: function () {
      if (this.all == null) {
        return null
      }

      if (this.filteredSheets.filter === '') {
        return this.all.list
      }

      return this.filteredSheets.list
    },

    currentSheets: function () {
      if (this.all == null ||
          !this.all.available ||
          this.all.module !== this.module) {
        return null
      }

      if (this.selection == null) {
        return this.referenceSheets
      }

      const result = this.referenceSheets.filter(
        i => i.sv === this.selection.surveillance.id
      )
      return result
    },

    flatDistribution: function () {
      if (this.currentSheets == null || this.module == null) {
        return null
      }

      try {
        const dist = distribution(this.module, this.currentSheets, this.year)
        return caracteristics.flatten[this.module](dist)
      } catch (e) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
        })
      }

      return null
    },

    caracteristics: function () {
      const result = {
        spiadi: `SPIADI${this.year}`,
        others: []
      }
      if (caracteristics.flatten[this.module] == null ||
          this.surveillance == null ||
          !this.surveillance.canGetStatistics(this.userId, this.module)) {
        return result
      }

      const m = this.surveillance.modules[this.module]
      if (m == null) {
        return result
      }

      m.dset.forEach(
        d => {
          if (d.step < 1) {
            return
          }

          if (!d.name.toLowerCase().includes('spiadi')) {
            result.others.push(d.name)
          }
        }

      )
      return result
    }
  },

  components: {
    'loading-text': loading,
    'sui-results-caracteristics': suiResultsCaracteristics,
    'sui-filter-input': suiFilterInput
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.form-inline {
  padding-left: 1rem;
  padding-right: 1rem;
}

.open-button-container {
  padding: 1rem;
}

.open-button {
  word-wrap: break-word;
  white-space: normal;
  height: 5rem;
}

</style>
